let token = null;
let setTokenCallback = null;

export const authStore = {
  getToken: () => token,
  setToken: (newToken) => {
    token = newToken;
    if (setTokenCallback) setTokenCallback(newToken); // update context
  },
  clear: () => {
    token = null;
    if (setTokenCallback) setTokenCallback(null);
  },
  registerContext: (setAccessToken) => {
    setTokenCallback = setAccessToken;
  },
};
